module.exports = __webpack_public_path__ + "cfc4eb6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Header/triangle.png
// module id = 925
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16